import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { environment } from '../../../../environments/environment.prod';
import { MUTATIONS } from './operations/mutations';
import { auth_queries } from './operations/querys';
import { map, tap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  public baseUrl: string = environment.baseUrl;
  private redirectUrl:any = null
  constructor(private apollo: Apollo) {}

  login(data: {}) {
    return this.apollo.mutate({
      mutation: MUTATIONS.login,
      variables: { data }
    });
  };

  loginWithToken(data: {}) {
    return this.apollo.mutate({
      mutation: MUTATIONS.loginWithToken,
      variables: data
    });
  };

  signUp(data: {}) {
    return this.apollo.mutate({
      mutation: MUTATIONS.signUp,
      variables: {data},
      errorPolicy:'all'
    })
  };

  validateEmail(token: string) {
    return this.apollo.mutate({
      mutation: MUTATIONS.validateEmail,
      variables: { token },
      errorPolicy:'all'
    });
  };

  refreshToken() {
    return this.apollo.mutate({
      mutation: MUTATIONS.refreshToken,
      variables: { refreshToken:localStorage.getItem('refreshToken') }
    })
  }

  storeToken(token: string): void {
    localStorage.setItem('accessToken', token);
  }

  passwordRecover(data: {}) {
    return this.apollo.mutate({
      mutation: MUTATIONS.passwordRecover,
      variables: { data }
    });
  };

  passwordReset(data: {}) {
    return this.apollo.mutate({
      mutation: MUTATIONS.passwordReset,
      variables: { data }
    });
  };

  activatePassword(data: {}) {
    return this.apollo.mutate({
      mutation: MUTATIONS.activatePassword,
      variables: { data }
    });
  }

  updatePassword(data: {}) {
    return this.apollo.mutate({
      mutation: MUTATIONS.updatePassword,
      variables: { data }
    });
  };

  getLoggedUser(){
    return this.apollo.query({
      query: auth_queries.getLoggedUser,
      fetchPolicy:'no-cache',
      errorPolicy:'all'
    });
  };
  getMe(){
    return this.apollo.query({
      query: auth_queries.getMe,
      fetchPolicy:'no-cache',
      errorPolicy:'ignore'
    });
  };

  logout(): void {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('refreshToken');
    window.location.href = '/login'; // Redirigir al login
  }

  setRedirectUrl(url: string): void {
    this.redirectUrl = url;
  }

  getRedirectUrl(): string | null {
    return this.redirectUrl;
  }

  clearRedirectUrl(): void {
    this.redirectUrl = null;
  }

}
